import { render, staticRenderFns } from "./Localizer.vue?vue&type=template&id=a981fab0&scoped=true&"
import script from "./Localizer.vue?vue&type=script&lang=js&"
export * from "./Localizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a981fab0",
  null
  
)

export default component.exports